import React from 'react';
import { selectLoader } from '../selectors';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Preloader as Loader } from 'planoplan-ui-kit/core/preloader';
import { Colors } from 'planoplan-ui-kit/core/colors';

const mapStateToProps = (state) => ({
  fetching: selectLoader(state).status,
});

export const View = ({ elements = [], isEmptyArray = false, children }) => {
  const isExists = elements.every((item) => {
    // флаг показывает что массив может быть пустым (если нужно для каждого элемента массива elemenst
    // можно создать массив isEmptyArray и искать по индексу)
    if (typeof item !== 'object' || isEmptyArray) {
      return !!item;
    }

    if (Array.isArray(item)) {
      return item.length;
    }

    return Object.values(item).length;
  });

  if (isExists) {
    return children;
  } else {
    return (
      <Wrapper>
        <Loader fill={Colors.planoplan_blue} />
      </Wrapper>
    );
  }
};

const enchance = compose(connect(mapStateToProps));

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
`;

export const Preloader = enchance(View);
